import React from 'react';

const CallToAction = () => {
  return (
    <div className="hero-call-to-action">
      <div className="container">
        Looking for a first-class business consultant?
        <button className="btn btn-secondary">
          Get a quote{' '}
          <span className="chev">
            <i className="bi bi-chevron-right"></i>
          </span>
        </button>
      </div>
    </div>
  );
};

export default CallToAction;
